<template>
	<BaseCmsLabel code="instashop_modal_title" :class="[mode]" default="Inspiracija" class="instashop-modal-title" tag="div"/>
	<BaseUiSwiper class="instashop-items-slider" :class="[mode]" :options="{
		slidesPerView: 1,
		slidesPerGroup: 1,
		autoHeight: true,
		initialSlide: instashopItemIndex,
		loop: mode == 'details' ? false : true,
		effect: 'fade',
		fadeEffect: {
			crossFade: true
		},
		navigation: {enabled: true},
	}">
		<BaseUiSwiperSlide v-for="item in instashopData" :key="item.id" class="instashop-item">
			<div class="pd-instashop-body">
				<BaseCatalogProductsWidget v-if="mode == 'details' && item?.images?.length ? getIds(item.images[0].imagemaps) : item.instashopIds?.length " :fetch="{id: mode == 'details' ? getIds(item.images[0].imagemaps) : item.instashopIds}" v-slot="{items: products}" >

					<div class="pd-instashop-col1">
						<figure class="instashop-image">
							<BaseUiImage :data="item.main_image_thumbs?.['width1000-height1000-crop1']" default="/images/no-image-1000.jpg" loading="lazy" />
							<span class="instashop-image-points" v-if="item?.images[0]?.imagemaps?.length">
								<template v-for="(imagemap,index) in [...item.images[0].imagemaps].sort((a, b) => a.id - b.id)" :key="imagemap.id">
									<span class="instashop-point" :style="{ top: `${imagemap.posRelative.y}%`, left: `${imagemap.posRelative.x}%` }" :class="{'active': instashopPointActive == index+1, 'instashop-point-top': imagemap.posRelative.y > 90}" @mouseenter="!tabletBreakpoint && instashopActive(index+1, imagemap.id)" @mouseleave="!tabletBreakpoint && instashopInactive()" @click="tabletBreakpoint && instashopToggle(index+1, imagemap.id)">
										<span class="instashop-num"><span>{{index+1}}</span></span>
										<template v-for="item in products" :key="item.id">
											<div class="instashop-tip" v-if="item.id == imagemap.id">
												<NuxtLink :to="item.url_without_domain" target="_parnet"><BaseCmsLabel code="instashop_detail" /></NuxtLink>
											</div>
										</template>
									</span>
								</template>
							</span>
						</figure>
					</div>
					<div class="pd-instashop-col2">
						<div class="pd-instashop-items" :class="{'c-items3': !mobileBreakpoint}" v-if="products?.length">
							<CatalogIndexEntryInstashop v-for="item in products" :key="item.id" :item="item" list="" :class="{'hover': item.id == instashopPointId}" />
						</div>
					</div>
				</BaseCatalogProductsWidget>
				<div v-else class="pd-instashop-col1">
					<figure class="instashop-image">
						<BaseUiImage :data="item.main_image_thumbs?.['width700-height700-crop1']" default="/images/no-image-700x700.jpg" loading="lazy" />
					</figure>
				</div>
			</div>
		</BaseUiSwiperSlide>
	</BaseUiSwiper>
</template>

<script setup>
	const props = defineProps(['instashopData', 'instashopItemIndex', 'mode']);
	const {mobileBreakpoint, tabletBreakpoint} = inject('rwd');

	const instashopPointActive = ref();
	const instashopPointId = ref();

	function instashopActive(index, imagemap){
		instashopPointActive.value = index;
		instashopPointId.value = imagemap;
	}
	function instashopInactive(){
		instashopPointActive.value = null;
		instashopPointId.value = null;
	}
	function instashopToggle(index, imagemap){
		if(instashopPointActive.value === index){
			instashopInactive();
		} else {
			instashopActive(index, imagemap);
		}
	}

	function getIds(items){
		const idsArray = [];
		items.forEach(element => {
			idsArray.push(element.id);
		});

		return idsArray;
	}
</script>

<style lang="less" scoped>
	.instashop-modal-title{
		font-size: 32px; line-height: 40px; font-weight: bold; padding-bottom: 11px;
		@media (max-width: @t){font-size: 28px; line-height: 36px;}
		@media (max-width: @tp){font-size: 24px; line-height: 32px; padding: 12px 15px;}
	}
	:deep(.swiper-navigation){
		position: absolute; right: 116px; top: 28px; display: flex; align-items: center; gap: 30px;
		@media (max-width: @t){right: 70px; top: 20px;}
		@media (max-width: @tp){top: 18px; right: 84px; gap: 24px;}
		@media (max-width: @m){display: none!important;}
	}
	:deep(.swiper-button){
		width: 30px; height: 30px; position: relative; display: flex; align-items: center; justify-content: center; font-size: 0;
		&:before{.icon-arrow-left(); font: 28px/1 var(--fonti); color: var(--primaryColor);}
		@media (max-width: @tp){
			width: 22px; height: 22px;
			&:before{font-size: 22px;}
		}
	}
	:deep(.swiper-button-next){
		&:before{.rotate(180deg);}
	}
	:deep(.swiper-button-lock){
		display: none;
	}

	.instashop-items-slider{
		border: 1px solid var(--borderColor);
		@media (max-width: @tp){border: unset;}
	}
	.pd-instashop-body{
		display: flex;
		@media (max-width: @tp){flex-flow: column;}
	}
	.pd-instashop-col1{
		width: 700px; flex-grow: 0; flex-shrink: 0;
		@media (max-width: @l){width: 500px;}
		@media (max-width: @t){width: 465px;}
		@media (max-width: @tp){width: 100%; aspect-ratio: 1;}
	}
	.pd-instashop-col2{
		flex-grow: 1; margin-left: 20px; padding: 10px 0; max-height: 700px; overflow-y: auto; 
		@media (max-width: @l){max-height: 500px;}
		@media (max-width: @t){max-height: 465px; margin-left: 10px;}
		@media (max-width: @tp){max-height: 100%; overflow: unset; margin-left: 0; padding: 4px 0;}
	}

	.instashop-image{position: relative; display: block; line-height: 0;}
	.instashop-image-points{position: absolute; top: 0; right: 0; bottom: 0; left: 0;}
	.instashop-point{
		position: absolute; display: flex; flex-flow: column; align-items: center; height: 30px; width: 30px; font-size: 16px;
		&.active{
			text-decoration: none; z-index: 20;
			.instashop-tip{opacity: 1; pointer-events: auto;}
			.instashop-num:after{opacity: 1; bottom: -12px;}
		}
		@media (max-width: @tp){width: 26px; height: 26px; font-size: 14px;}
	}
	.instashop-point-top{
		.instashop-tip{
			top: unset; bottom: 42px;
			&:before{top: unset; bottom: -4px;}
		}
		&.active{
			.instashop-num:before{opacity: 1; top: -12px;}
		}
	}
	.instashop-num{
		display: flex; position: relative; align-items: center; justify-content: center; font-weight: bold; width: 30px; height: 30px; background: #fff; border-radius: 200px;
		span{position: relative; z-index: 1; line-height: 30px; padding-top: 2px; text-indent: 1px;}
		&:before{.pseudo(auto,auto); top: 0; right: 0; bottom: 0; left: 0; border-radius: 200px; opacity: 0; .transition(opacity);}
		&:after{.pseudo(auto,auto); top: 0; right: 0; bottom: 0; left: 0; border-radius: 200px; opacity: 0; .transition(opacity);}
		@media (max-width: @tp){
			width: 26px; height: 26px;
			span{line-height: 26px; text-indent: 0; padding-top: 0;}
		}
	}
	.instashop-tip{
		position: absolute; top: 42px; color: #fff; font-weight: bold; font-size: 11px; line-height: 20px; background: #000; text-transform: uppercase; width: 160px; height: 30px; display: flex; align-items: center; justify-content: center; box-shadow: 0 0px 10px 0 rgba(0,0,0,0.1); left: -64px; opacity: 0; pointer-events: none; .transition(opacity); z-index: 10;
		span{position: relative; z-index: 1;}
		a{text-decoration: none; color: #fff;}
		&:before{.pseudo(8px,8px); .rotate(45deg); left: 50%; margin-left: -5px; top: -4px; background: #000;}
	}

	//DETAILS
	.instashop-modal-title.details{
		text-align: center; font-size: 38px; line-height: 50px; font-weight: normal; padding-bottom: 32px;
		@media (max-width: @tp){font-size: 24px; line-height: 32px; text-align: left; padding: 0 0 12px;}
	}
	.instashop-items-slider.details{
		position: relative; display: block;
		:deep(.swiper-navigation){display: flex; justify-content: space-between; position: absolute; top: 50%; left: -90px; right: -90px; height: 50px; margin-top: -15px; gap: unset;}
		:deep(.swiper-button){
			aspect-ratio: 1; width: initial; height: initial; 
			&:before{font-size: 30px; line-height: 30px;}
		}
		@media (max-width: @l){
			:deep(.swiper-navigation){left: -30px; right: -30px;}
		}
		@media (max-width: @t){
			:deep(.swiper-navigation){left: -24px; right: -24px;}
		}
		@media (max-width: @tp){
			width: calc(~"100% - -30px"); margin-left: -15px;
		}
	}
</style>